import { useState } from "react";

import { DayTwoData } from "./../data/data";

const DayTwo = () => {
  const [data] = useState(DayTwoData);
  return (
    <div className="content">
      <h1 className="heading-tertiary">Day 2</h1>
      <div className="cards">
        {data.map((item) => {
          return (
            <div className="card" key={item.id}>
              <div className="card__header">
                <h1 className="card__title">{item.title}</h1>
                <h2 className="card__subtitle">{item.speaker}</h2>
              </div>
              <div className="card__actions">
                <a
                  href={item.ytURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card__link"
                >
                  Talk
                </a>
                {item.slidesURL ? (
                  <a
                    href={item.slidesURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="card__link"
                  >
                    Slides
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DayTwo;
